import styled from 'styled-components';
import { BtnSuccess } from '../../styles/Buttons';

export const SubHeaderPage = styled.div`
  width: 100%;
  div:first-child {
    padding: 0;
  }
  h2 {
    margin-top: 10px;
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
    padding: 12px 0 17px 17px;
  }
`;

export const BtnAction = styled(BtnSuccess)`
  font-weight: bold;
  height: 50px;
`;
